import lang from "@/views/modules/Funders/language/en";

let searchFieldsDef = {
    'name': {
        label: lang.LBL_NAME,
    },
    'status': {
        label: lang.LBL_STATUS,
        type:'select',
        field_infos:'status'
    },
};
export default { searchFieldsDef }